<div *ngIf="!isAuthInitialized" class="loading-container">
  <div class="loading-spinner">
    <!-- Bootstrap-enhanced spinner -->
    <div class="spinner"></div>
    
    <!-- Loading text with animated dots -->
    <p class="mb-0">
      Initializing
      <span class="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </p>
    
    <!-- Subtitle -->
    <div class="loading-subtitle">
      Setting up your workspace
    </div>
    
    <!-- Progress bar -->
    <div class="loading-progress">
      <div class="loading-progress-bar"></div>
    </div>
  </div>
</div>

<router-outlet *ngIf="isAuthInitialized"></router-outlet>
